import { useDispatch } from 'react-redux';
import { fetchRepairRequest } from '../stores/repairRequest/slice';
import { AppDispatch } from '../stores/store';
import { INSPEX_PATHNAME } from '../_constants/Const';
import { isFulfilled } from '@reduxjs/toolkit';
import { isGetRepairRequest } from '../_utils/typeGuardUtils';
import { API_CODE } from '../_constants/apiConst';
import { postTemporaryDataReflection } from '../services/api/temporaryDataReflection';
import { useNavigate } from 'react-router-dom';

const useTempDataReflection = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const tempDataReflection = async (
    key: string,
    rmaNo: string,
    showApiError: (
      apiError: unknown,
      apiCode: string,
      onCloseCallback?: () => void,
    ) => void,
    showTypeError: (apiCode: string) => void,
  ) => {
    try {
      // 一時データ保存API呼び出し
      await postTemporaryDataReflection(key);
    } catch (error) {
      showApiError(error, API_CODE.TEMP_DATA_REFLECTION, () => {
        navigate(INSPEX_PATHNAME.RMA_SEARCH);
      });
      return;
    }
    // 修理依頼情報を取得
    const response = await dispatch(fetchRepairRequest({ rmaNo }));
    if (isFulfilled(response)) {
      if (!isGetRepairRequest(response.payload)) {
        showTypeError(API_CODE.REPAIR_REQUEST);
      }
    } else {
      showApiError(response.payload, API_CODE.REPAIR_REQUEST, () =>
        navigate(INSPEX_PATHNAME.RMA_SEARCH),
      );
    }
  };

  return {
    tempDataReflection,
  };
};

export default useTempDataReflection;
